import { AxiosError, AxiosResponse } from 'axios';
import { FetchResult, instance } from './config';
import { useMutation } from '@tanstack/react-query';

async function patchIssueReportList(body: number[]): Promise<AxiosResponse<FetchResult<string>>> {
  const response = await instance.patch(`/images/issue-reports`, { issueReportIds: [...body] });
  return response;
}

const usePatchIssueReportList = (
  onSuccess?: (data: AxiosResponse<FetchResult<string>>) => void,
  onError?: (err: AxiosError) => void
) => {
  const { data, mutateAsync } = useMutation({
    mutationKey: ['patch', `/images/issue-reports`],
    mutationFn: (body: number[]) => patchIssueReportList(body),
    onSuccess: (data) => {
      onSuccess?.(data);
    },
    onError: (err: AxiosError) => {
      onError?.(err);
    },
    retry: false
  });

  return { data, mutateAsync };
};

export default usePatchIssueReportList;
